import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute,  ActivationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { MessageService } from '../message.service';
import { LoggerService } from '../logger.service';
import { RoughcheckService } from '../roughcheck.service';

/**
 * MainMenuComponent to manage main navigation
 */
@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
})
export class MainMenuComponent implements OnInit, OnDestroy {

  title = 'Roughcheck - The Checklist with Added Intelligence';
  rref: string;
  aref: string;
  page = '';
  @Input() linkRoughcheck = [];
  @Input() linkAssessment = [];
  @Input() linkSections = [];
  @Input() linkReport = [];
  @Input() linkAction = [];
  @Input() linkHelp = [];

  // An event triggered when the Router finishes activating a route.
  navActivationEnd: Observable<ActivationEnd>;

  constructor(
    private service: RoughcheckService,
    private logger: LoggerService,
    private message: MessageService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.navActivationEnd = router.events.pipe(
      filter(evt => evt instanceof ActivationEnd)
    ) as Observable<ActivationEnd>;

  }

  ngOnInit() {
    this.service.roughcheckRRef.subscribe(
      {
        next: (v) => {
          this.rref = v;
          this.updateLinks();
        }
      });
    this.service.assessmentARef.subscribe(
      {
        next: (v) => {
          this.aref = v;
          this.updateLinks();
        }
      });
    // this.aref = this.service.getARef();
    // this.rref = this.service.getRRef();
    // Initialise links
    this.updateLinks();
    this.navActivationEnd.subscribe(evt => {
      const path = evt.snapshot.routeConfig.path;
      if (path === 'home') {
        this.page = 'home';
      } else if (path === 'a/:rref/assessment') {
        this.page = 'info';
      } else if (path === 'a/:rref/:aref/assessment') {
        this.page = 'info';
      } else if (path === 'a/:rref/:aref/sections') {
        this.page = 'assessment';
      } else if (path === 'a/:rref/:aref/section/:id') {
        this.page = 'assessment';
      } else if (path === 'a/:rref/:aref/section/:id/:id/notes') {
        this.page = 'assessment';
      } else if (path === 'a/:rref/:aref') {
        this.page = 'roughcheck';
      } else if (path === 'a/:rref') {
        this.page = 'roughcheck';
      } else if (path === 'start') {
        this.page = 'roughcheck';
      } else if (path === 'a/:rref/:aref/report') {
        this.page = 'report';
      } else if (path === 'a/:rref/:aref/action') {
        this.page = 'action';
      } else if (path === 'help') {
        this.page = 'help';
      } else if (path === 'a/:rref/help') {
        this.page = 'help';
      } else if (path === 'a/:rref/:aref/help') {
        this.page = 'help';
      } else {
        this.page = 'unknown';
      }
    });

  }

  ngOnDestroy() {
    this.service.roughcheckRRef.unsubscribe();
    this.service.assessmentARef.unsubscribe();
  }

  /**
   * Update links when references change
   */
  updateLinks(): void {
    if (this.aref) {
      this.linkRoughcheck = ['/a', this.rref, this.aref];
      this.linkAssessment = ['/a', this.rref, this.aref, 'assessment'];
      this.linkSections = ['/a', this.rref, this.aref, 'sections'];
      this.linkReport = ['/a', this.rref, this.aref, 'report'];
      this.linkAction = ['/a', this.rref, this.aref, 'action'];
      this.linkHelp = ['/a', this.rref, this.aref, 'help'];
    } else if (this.rref) {
      this.linkRoughcheck = ['/a', this.rref, this.aref];
      this.linkAssessment = ['/a', this.rref, 'assessment'];
      this.linkSections = ['/a', this.rref, 'sections'];
      this.linkReport = ['/a', this.rref, 'report'];
      this.linkAction = ['/a', this.rref, 'action'];
      this.linkHelp = ['/a', this.rref, 'help'];
    } else {
      this.linkRoughcheck = ['/start'];
      this.linkAssessment = ['/a', this.rref, 'assessment'];
      this.linkSections = ['/start'];
      this.linkReport = ['/start'];
      this.linkAction = ['/start'];
      this.linkHelp = ['/help'];
    }
  }

  /**
   * Function to identify an aref
   */
  isAref(aref) {
    if (aref === '00000000-0000-0000-0000-000000000000') {
      return true;
    } else if (aref) {
      return null;
    } else {
      return true;
    }
  }

}
